import { useRef, useState } from "react";

export default function useMusicPlayer(audio) {
  const [queue, setQueue] = useState([]);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [selectedAlbum, setselectedAlbum] = useState();
  return {
    audioRef,
    queue,
    setQueue,
    playing,
    setPlaying,
    duration,
    setDuration,
    currentTime,
    setCurrentTime,
    currentTrack,
    setCurrentTrack,
    selectedAlbum,
    setselectedAlbum,
  };
}
